import React from 'react'
import './Works.css'
import Upwork from "../../img/Upwork.png";
import Fiverr from "../../img/fiverr.png";
import Amazon from "../../img/amazon.png";
import Shopify from "../../img/Shopify.png";
import Facebook from "../../img/Facebook.png";
import { themeContext } from '../../Context';
import { useContext } from "react";
import {motion} from 'framer-motion'


const Works = () => {
    const transition={duration: 10,type: 'spring'}
    const theme =useContext(themeContext)
  const darkMode=theme.state.darkMode
  return (
   <div className="works">
    <div className="awesome">
    <span style={{color:darkMode?'white':''}}>Tech</span>
    <span>Stack</span>
    <span>I am open to adopting any tech stack, but these are my main areas of expertise
    <br />
    <br />
    C++, C, AppDev, React and Backend

    </span>
    <button className="button s-button">Contact me</button>

    <div className="blur s-blur1" style={{background: "#ABF1FF94"}}></div>
    </div>

    {/* right side */}
    
     <motion.div
     initial={{rotate:45}}
     whileInView={{rotate: 0}}
     viewport={{margin:'40px'}}
     transition={{duration: 3.5, type:'spring'}}
     className="w-right">
        <motion.div 
        transition={transition}
        whileInView={{rotate:360}}
        
        className="w-mainCircle">
            <div className="w-secCircle">
                <div className='C'> <img src={Upwork} alt="" /></div>
            </div>
            <div className="w-secCircle">
                <div className='F'> <img src={Fiverr} alt="" /></div>
                
            </div>
            <div className="w-secCircle">
                <img src={Amazon} alt="" />
            </div>
            <div className="w-secCircle">
                <img src={Shopify} alt="" />
            </div>
            <div className="w-secCircle">
                <div className="C"><img src={Facebook} alt="" /></div>
            </div>
        </motion.div>
        <motion.div 
        transition={transition}
        initial={{top:'0rem',left:'17rem'}}
        whileInView={{left: '18rem',top: '0rem'}}
        
        className="w-backCircle blueCircle"></motion.div>
        <motion.div 
        transition={transition}
        initial={{top:'8rem',left:'16rem'}}
        whileInView={{left: '18rem',top: '8rem'}}
        className="w-backCircle yellowCircle"></motion.div>
     </motion.div>

   </div>
  )
}

export default Works